// @ts-nocheck

/**
 * Moulding-Process
 * API for accessing Moulding Process data
 *
 * The version of the OpenAPI document: 1
 * Contact: team07.04.01@o365.corp.LEGO.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { BatchItemIEnumerableEnvelope } from '../model/models';
import { MouldDataBatchRequestContract } from '../model/models';
import { OperationalMouldDataContractEnvelope } from '../model/models';
import { ProblemDetails } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class MouldsService {

    protected basePath = 'https://integration.api.legogroup.io/platformengineering/mouldtechnologyrandd/moulding-process';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param mouldId
     * @param apiVersion
     * @param correlationId
     * @param userAgent
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMouldsMouldIdPerformanceDataGet(mouldId: string, apiVersion: string, correlationId?: string, userAgent?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<OperationalMouldDataContractEnvelope>;
    public apiMouldsMouldIdPerformanceDataGet(mouldId: string, apiVersion: string, correlationId?: string, userAgent?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpResponse<OperationalMouldDataContractEnvelope>>;
    public apiMouldsMouldIdPerformanceDataGet(mouldId: string, apiVersion: string, correlationId?: string, userAgent?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpEvent<OperationalMouldDataContractEnvelope>>;
    public apiMouldsMouldIdPerformanceDataGet(mouldId: string, apiVersion: string, correlationId?: string, userAgent?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<any> {
        if (mouldId === null || mouldId === undefined) {
            throw new Error('Required parameter mouldId was null or undefined when calling apiMouldsMouldIdPerformanceDataGet.');
        }
        if (apiVersion === null || apiVersion === undefined) {
            throw new Error('Required parameter apiVersion was null or undefined when calling apiMouldsMouldIdPerformanceDataGet.');
        }

        let headers = this.defaultHeaders;
        if (apiVersion !== undefined && apiVersion !== null) {
            headers = headers.set('api-version', String(apiVersion));
        }
        if (correlationId !== undefined && correlationId !== null) {
            headers = headers.set('correlation-id', String(correlationId));
        }
        if (userAgent !== undefined && userAgent !== null) {
            headers = headers.set('user-agent', String(userAgent));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/json',
                'text/plain',
                'application/json',
                'application/problem+json',
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<OperationalMouldDataContractEnvelope>(`${this.configuration.basePath}/api/moulds/${encodeURIComponent(String(mouldId))}/performance/data`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param apiVersion
     * @param correlationId
     * @param userAgent
     * @param mouldDataBatchRequestContract
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMouldsPerformanceDataPost(apiVersion: string, correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<BatchItemIEnumerableEnvelope>;
    public apiMouldsPerformanceDataPost(apiVersion: string, correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpResponse<BatchItemIEnumerableEnvelope>>;
    public apiMouldsPerformanceDataPost(apiVersion: string, correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpEvent<BatchItemIEnumerableEnvelope>>;
    public apiMouldsPerformanceDataPost(apiVersion: string, correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<any> {
        if (apiVersion === null || apiVersion === undefined) {
            throw new Error('Required parameter apiVersion was null or undefined when calling apiMouldsPerformanceDataPost.');
        }

        let headers = this.defaultHeaders;
        if (apiVersion !== undefined && apiVersion !== null) {
            headers = headers.set('api-version', String(apiVersion));
        }
        if (correlationId !== undefined && correlationId !== null) {
            headers = headers.set('correlation-id', String(correlationId));
        }
        if (userAgent !== undefined && userAgent !== null) {
            headers = headers.set('user-agent', String(userAgent));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/json',
                'text/plain',
                'application/json',
                'application/problem+json',
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'text/json',
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<BatchItemIEnumerableEnvelope>(`${this.configuration.basePath}/api/moulds/performance/data`,
            mouldDataBatchRequestContract,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param mouldId
     * @param correlationId
     * @param userAgent
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1MouldsMouldIdPerformanceDataGet(mouldId: string, correlationId?: string, userAgent?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<OperationalMouldDataContractEnvelope>;
    public apiV1MouldsMouldIdPerformanceDataGet(mouldId: string, correlationId?: string, userAgent?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpResponse<OperationalMouldDataContractEnvelope>>;
    public apiV1MouldsMouldIdPerformanceDataGet(mouldId: string, correlationId?: string, userAgent?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpEvent<OperationalMouldDataContractEnvelope>>;
    public apiV1MouldsMouldIdPerformanceDataGet(mouldId: string, correlationId?: string, userAgent?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<any> {
        if (mouldId === null || mouldId === undefined) {
            throw new Error('Required parameter mouldId was null or undefined when calling apiV1MouldsMouldIdPerformanceDataGet.');
        }

        let headers = this.defaultHeaders;
        if (correlationId !== undefined && correlationId !== null) {
            headers = headers.set('correlation-id', String(correlationId));
        }
        if (userAgent !== undefined && userAgent !== null) {
            headers = headers.set('user-agent', String(userAgent));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/json',
                'text/plain',
                'application/json',
                'application/problem+json',
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<OperationalMouldDataContractEnvelope>(`${this.configuration.basePath}/api/v1/moulds/${encodeURIComponent(String(mouldId))}/performance/data`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param correlationId
     * @param userAgent
     * @param mouldDataBatchRequestContract
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiV1MouldsPerformanceDataPost(correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<BatchItemIEnumerableEnvelope>;
    public apiV1MouldsPerformanceDataPost(correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpResponse<BatchItemIEnumerableEnvelope>>;
    public apiV1MouldsPerformanceDataPost(correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<HttpEvent<BatchItemIEnumerableEnvelope>>;
    public apiV1MouldsPerformanceDataPost(correlationId?: string, userAgent?: string, mouldDataBatchRequestContract?: MouldDataBatchRequestContract, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/json' | 'text/plain' | 'application/json' | 'application/problem+json' }): Observable<any> {

        let headers = this.defaultHeaders;
        if (correlationId !== undefined && correlationId !== null) {
            headers = headers.set('correlation-id', String(correlationId));
        }
        if (userAgent !== undefined && userAgent !== null) {
            headers = headers.set('user-agent', String(userAgent));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/json',
                'text/plain',
                'application/json',
                'application/problem+json',
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'text/json',
            'application/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<BatchItemIEnumerableEnvelope>(`${this.configuration.basePath}/api/v1/moulds/performance/data`,
            mouldDataBatchRequestContract,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
